<template>
  <div :dir="language === 'he' ? 'rtl' : 'ltr'" id="app">
    <b-navbar toggleable="lg" variant="light" bg="light">
      <b-container>
        <b-navbar-brand href="#">סטטוס חדרים
          <span style="font-size: small" class="ml-2">  v{{ version }}</span>
        </b-navbar-brand>
        <b-navbar-nav class="mx-auto">
          <h1 class="mikvah-title text-center my-0">{{ ProjectData && ProjectData.MikvahName }}</h1>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <span class="clock">{{ currentTime }}</span>
        </b-navbar-nav>
      </b-container>
    </b-navbar>

    <b-container>
      <b-row>
        <b-col v-for="room in rooms" :key="room.id" cols="12" md="6" lg="4" class="mb-4">
          <b-card
              :bg-variant="getBgVariant(room.StatusSubCategory)"
              :text-variant="getTextVariant(room.StatusSubCategory)"
              header-class="text-center"
              class="h-100 d-flex flex-column justify-content-between"
              @click="openModal(room)"
          >
            <template #header>
<!--     בצד ימין מספר החדר מודגש בצד שמאל טיימר         -->
              <div class="d-flex justify-content-between">
                <span style="font-weight: bold">חדר {{ room.RoomName || room.RoomNum }}</span>
                <span>{{ getTimer(room) }}</span>
              </div>
            </template>
            <div class="flex-grow-1">
              <b-card-text class="text-center">
                סטטוס:
                <span v-if="room.StatusSubCategory && room.StatusCategory !== room.StatusSubCategory" class="text-center">{{ room.StatusSubCategory }} / </span>
                {{ room.StatusCategory }}
              </b-card-text>
<!--  אם getShortcutsByStatus מחזיר מערך שאינו ריק יש ליצור לחצנים לפי האפשרויות ולשלב צבע מ getShortcutsButtonsColor            -->
              <b-button-group v-if="getShortcutsByStatus(room.StatusSubCategory).length" class="d-flex justify-content-center">
                <b-button v-for="(shortcut, index) in getShortcutsByStatus(room.StatusSubCategory)" :key="index"
                          :style="getButtonStyle(shortcut)"
                          class="custom-button"
                          @click.stop="changeStatus(room.RoomNum, getShortcutStatusCode(shortcut))">
                  {{ shortcut }}
                </b-button>
              </b-button-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
<!--      <b-button @click="fetchRooms" variant="primary">רענן חדרים</b-button>-->
    </b-container>

    <!-- Modal -->
    <b-modal v-model="showModal" :title="selectedRoom ? 'סטטוס חדר ' + selectedRoom.RoomNum : ''" ok-only ok-title="ביטול"  dir="rtl">
      <div class="text-center">
        <b-card-text>סטטוס נוכחי: {{ selectedRoom && selectedRoom.StatusSubCategory }}</b-card-text>
        <b-card-text>בחר סטטוס חדר:</b-card-text>
      </div>
      <b-overlay :show="inLoad" rounded="sm">
        <div class="text-center">
          <b-button v-for="(status, index) in statusOptions" :key="index" variant="outline-dark" class="mb-2" block
                    :style="selectedRoom && selectedRoom.StatusSubCategory === status ? 'background-color: #007bff;color: white;' : ''"
                    @click="setStatus(status, index)">
            {{ status }}
          </b-button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
const moment = require('moment')

export default {
  data() {
    return {
      currentTime: '',
      rooms: [],
      selectedRoom: null,
      showModal: false,
      statusOptions: ['לא פעיל', 'פנוי וריק', 'לקוחה בדרך', 'מתכוננת', 'קריאת בלנית', 'ראשונה בתור', 'בטבילה', 'אחרי טבילה', 'דרוש ניקוי', 'בניקוי', 'לבדוק מצב חדר'],
      newStatus: '',
      newStatusCode: null,
      homeUrl: 'https://kolhator.net',
      isLocal: false,
      ProjectID: null,
      ProjectData: null,
      language: 'he',
      interval: null,
      inLoad: false,
      // מהגדרות הפרוייקט
      version: null,
    }
  },
  mounted() {
    let searchParams = new URLSearchParams(window.location.search);
    this.ProjectID = searchParams.get('ProjectID')
    this.token = searchParams.get('token')
    this.isLocal = searchParams.get('isLocal') === 'true'
    if (this.isLocal && searchParams.get('homeUrl')) {
      this.homeUrl = searchParams.get('homeUrl')
    }
    if (!this.ProjectID) {
      return alert('לא נמצא פרוייקט')
    }
    this.init()
    this.startClock()
    this.version = require('../package.json').version
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    init() {
      const url = this.homeUrl + `/balanit/api/${this.ProjectID}/init` + (this.token ? `?token=${this.token}` : '')
      fetch(url)
          .then(response => response.json())
          .then(data => {
            this.ProjectData = data
            if (data.language) {
              this.language = data.language
            }
            console.log(data)
          })
          .catch(error => {
            console.error('Error:', error)
          })
      this.fetchRooms()
    },
    fetchRooms() {
      const url = this.homeUrl + `/balanit/api/${this.ProjectID}/getRoomsStatus` + (this.token ? `?token=${this.token}` : '')
      fetch(url)
          .then(response => response.json())
          .then(data => {
            this.rooms = data.data
            // console.log(data.data)
          })
          .catch(error => {
            console.error('Error:', error)
          })
    },
    getTimer(room) {
      let updatedAt = room.updatedAt
      if (!updatedAt || room.StatusCategory === 'פנוי') {
        return '00:00'
      }
      let now = moment()
      let then = moment(updatedAt)
      let diff = now.diff(then, 'seconds')
      let hours = Math.floor(diff / 3600)
      let minutes = Math.floor((diff % 3600) / 60)
      let seconds = diff % 60
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      return `${hours}:${minutes}:${seconds}`
    },
    startClock() {
      this.interval = setInterval(() => {
        // console.log('tick', new Date())
        const now = new Date()
        this.currentTime = now.toLocaleTimeString()
        this.fetchRooms()
      }, 1000)
    },
    getBgVariant(status) {
      switch (status) {
        case 'לא פעיל':
          return 'light'
        case 'פנוי וריק':
          return 'success'
        case 'לקוחה בדרך':
          return 'warning'
        case 'מתכוננת':
          return 'info'
        case 'קריאת בלנית':
        case 'ראשונה בתור':
          return 'primary'
        case 'בטבילה':
          return 'danger'
        case 'אחרי טבילה':
          return 'dark'
        case 'דרוש ניקוי':
        case 'בנקיון':
          return 'light'
        case 'לבדוק מצב חדר':
          return 'danger'
        case 'לא ידוע':
        default:
          return 'light'
      }
    },
    getTextVariant(status) {
      switch (status) {
        case 'קריאת בלנית':
        case 'ראשונה בתור':
        case 'בטבילה':
        case 'אחרי טבילה':
          return 'white'
        case 'פנוי וריק':
          return 'dark'
        default:
          return 'dark'
      }
    },
    openModal(room) {
      this.selectedRoom = room
      this.showModal = true
    },
    setStatus(status, index) {
      this.newStatus = status
      this.newStatusCode = index
      this.changeStatus()
    },
    async changeStatus(RoomNum, newStatusCode) {
      console.log(RoomNum, newStatusCode)
      if ((RoomNum && newStatusCode) || (this.selectedRoom && this.newStatusCode !== null)) {
        try {
          this.inLoad = false
          const url = `${this.homeUrl}/balanit/api/${this.ProjectID}/updateManualStatusCode?RoomNum=${RoomNum ? RoomNum : this.selectedRoom.RoomNum}&StatusCode=${newStatusCode ? newStatusCode : this.newStatusCode}` + (this.token ? `&token=${this.token}` : '')
          const response = await fetch(url, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          const data = await response.json()

          // עדכון סטטוס מקומי לאחר הצלחה
          if (data.status === 'ok') {
            this.selectedRoom.StatusSubCategory = this.newStatus
            this.showModal = false
            this.inLoad = false
            /*this.$bvToast.toast('סטטוס עודכן בהצלחה', {
              title: 'הצלחה',
              variant: 'success',
              autoHideDelay: 5000,
            })*/
          } else {
            this.$bvToast.toast(data.message, {
              title: 'שגיאה',
              variant: 'danger',
              autoHideDelay: 5000,
            });
            this.inLoad = false
          }
        } catch (error) {
          console.error('Failed to update status:', error)
        }
      }
    },
    getShortcutsByStatus(status) {
      switch (status) {
        case 'לא פעיל':
        case 'פנוי וריק':
        case 'לקוחה בדרך':
        case 'מתכוננת':
          return []
        case 'קריאת בלנית':
        case 'ראשונה בתור':
          return ['ביטול קריאה', 'יציאה לטבילה']
        case 'בטבילה':
          return ['אחרי טבילה']
        case 'אחרי טבילה':
          return ['לבדוק מצב חדר']
        case 'דרוש ניקוי':
          return ['בניקוי']
        case 'בניקוי':
          return ['נקי']
        case 'לבדוק מצב חדר':
          return ['פנוי וריק', 'דרוש ניקוי']
        case 'לא ידוע':
        default:
          return []
      }
    },
    getShortcutsButtonsColor(status) {
      switch (status) {
        case 'ביטול קריאה':
         return 'danger'
        case 'יציאה לטבילה':
          return 'primary'
        case 'אחרי טבילה':
          return 'success'
        case 'לבדוק מצב חדר':
          return 'warning'
        case 'נקי':
          return 'info'
        case 'בניקוי':
          return 'dark'
        default:
          return 'light'
      }
    },
    getShortcutStatusCode(shortcut) {
      switch (shortcut) {
        case 'ביטול קריאה':
          return 3
        case 'יציאה לטבילה':
          return 6
        case 'אחרי טבילה':
          return 7
        case 'לבדוק מצב חדר':
          return 10
        case 'נקי':
          return 1
        case 'דרוש ניקוי':
          return 8
        case 'בניקוי':
          return 9
        default:
          return null
      }
    },
    getButtonStyle(shortcut) {
      switch (shortcut) {
        case 'ביטול קריאה':
          return {
            backgroundColor: '#dc3545', // אדום כהה
            color: 'white'
          };
        case 'יציאה לטבילה':
          return {
            backgroundColor: '#007bff', // כחול
            color: 'white'
          };
        case 'אחרי טבילה':
          return {
            backgroundColor: '#28a745', // ירוק
            color: 'white'
          };
        case 'לבדוק מצב חדר':
          return {
            backgroundColor: '#ffc107', // צהוב
            color: 'black'
          };
        case 'נקי':
          return {
            backgroundColor: '#17a2b8', // טורקיז
            color: 'white'
          };
        case 'בניקוי':
          return {
            backgroundColor: '#343a40', // אפור כהה
            color: 'white'
          };
        default:
          return {
            backgroundColor: '#f8f9fa', // אפור בהיר
            color: 'black'
          };
      }
    },
  }
}
</script>

<style>
body {
  font-family: 'Assistant', sans-serif;
}

.mikvah-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
}

.clock {
  font-size: 1.5rem;
  font-weight: bold;
}

.card {
  min-height: 120px; /* גובה מינימלי */
}
.custom-button {
  border: none; /* מבטל את הגבול */
  border-radius: 10px; /* פינות מעוגלות יותר */
  padding: 12px 25px;
  font-size: 1.1rem; /* גודל גופן גדול יותר */
  font-weight: bold;
  margin: 10px; /* מרווח בין הכפתורים */
  transition: box-shadow 0.3s, transform 0.2s; /* הסר את מעבר הרקע */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15); /* צל מודגש */
}


.custom-button:hover {
  background: linear-gradient(to bottom, #0056b3, #003f7f); /* מעברי צבע כהה יותר בריחוף */
  color: white;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.25); /* צל חזק יותר בריחוף */
  transform: scale(1.07); /* הגדלה משמעותית יותר כדי להבליט את הלחצן בריחוף */
}

.custom-button:active {
  background: #003f7f; /* צבע כהה ביותר בעת לחיצה */
  transform: scale(0.95); /* הקטנה קלה בעת לחיצה */
}


.b-navbar {
  width: 100%;
  max-width: 1112px;
  margin: 0 auto;
}
</style>
